import *as THREE from 'three'


export type ModeOfAnim = number

export default class {
  mesh: THREE.Mesh | THREE.Object3D 
  active = false
  paused = true
  rotationAlpha = .2 
  opacityAlpha = .1
  scaleAlpha = .05
  mode = 1
  minOffset = 1
  y = .1
  
  constructor(mesh: THREE.Mesh | THREE.Object3D) {
    this.mesh = mesh

    //@ts-ignore
    mesh.material.opacity = 0
  }  

  setMode(mode: ModeOfAnim) {
    // this.mode = mode
  }

  setActive(active: boolean) {
    this.active = active
  }

  play() {
    this.paused = false
  }

  pause() {
    this.paused = true
  }

  stop() {
    this.active = false
    this.paused = true

    //@ts-ignore
    this.mesh.material.opacity = 0
  }
  
  updateScale() {}
  
  updateOpacity() {
    const { mesh, opacityAlpha, paused } = this
    
    //@ts-ignore
    const targetOpacity = (mesh.material.opacity + opacityAlpha * (paused ? -1 : 1))

      
    if(targetOpacity <= 1 && targetOpacity >= 0) {
      //@ts-ignore
      mesh.material.opacity = +targetOpacity.toFixed(1)
    }

    this.y = this.y >= 2 ? this.minOffset : this.y + this.scaleAlpha

    //@ts-ignore
    mesh.material.map.repeat.set(1, this.y)
  }
  
  update() {

    if(this.active) {
      // mesh.rotation.set(0, rotationAlpha + mesh.rotation.y, 0)  
      this.updateOpacity()
    }
  }
}